<template>
  <div class="layout-content">
    <headBox title="团财险保单详情" :showBack="true"></headBox>
    <div class="content">
      <el-tabs v-model="tabVal" v-if="(userinfo.level != 2 && userinfo.level != 3) || productCategory != 2">
        <el-tab-pane label="投保信息" name="1"></el-tab-pane>
        <el-tab-pane label="人员清单" name="2" v-if="productCategory == 1"></el-tab-pane>
        <el-tab-pane label="保全信息" name="3" v-if="productCategory == 1"></el-tab-pane>
        <el-tab-pane label="发票信息" name="4" v-if="userinfo.level == 1"></el-tab-pane>
        <el-tab-pane label="服务费信息" name="5" v-if="userinfo.level == 1"></el-tab-pane>
      </el-tabs>

      <!-- 投保信息 -->
      <holderInfo v-if="tabVal == 1" :id="id"></holderInfo>

      <!-- 人员清单 -->
      <insureList v-else-if="tabVal == 2 && productCategory == 1" :id="id" :policyNo="policyNo" :orderNo="orderNo"></insureList>

      <!-- 保全信息 -->
      <peservationInfo v-else-if="tabVal == 3 && productCategory == 1"></peservationInfo>

      <!-- 发票信息 -->
      <invoiceInfo v-else-if="tabVal == 4 && userinfo.level == 1"></invoiceInfo>

      <!-- 服务费信息(费用) -->
      <commissionInfo v-else-if="tabVal == 5"></commissionInfo>
    </div>
  </div>
</template>
<script>
import holderInfo from "./components/holderInfo";
import insureList from './components/insureList';
import peservationInfo from './components/peservationInfo';
import invoiceInfo from './components/invoiceInfo';
import commissionInfo from './components/commissionInfo';
import headBox from '@/components/head.vue';

export default {
  components: {
    holderInfo,
    insureList,
    peservationInfo,
    invoiceInfo,
    commissionInfo,
    headBox
  },
  data() {
    return {
      tabVal: "1",
      id: null,
      policyNo: null,
      orderNo: null,
      productCategory: null,
      userinfo: {}
    };
  },
  created() {
    this.userinfo = this.$tools.getLocal("userinfo");
    this.id = this.$route.query.id;
    this.policyNo = this.$route.query.policyNo;
    this.orderNo = this.$route.query.orderNo;
    //财险只显示三个标签  投保信息、发票信息、服务费信息
    this.productCategory = this.$route.query.productCategory; //1-团险 2-财产险 3、个险

    if (localStorage.getItem('isApplyBack')) {
      this.tabVal = '4';
      setTimeout(() => {
        localStorage.removeItem('isApplyBack');
      }, 500);
    }
  },
  methods: {
    backPage() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-content {
  background-color: #fff;
  position: relative;
  .content {
    padding: 0 20px;
  }
  /deep/.el-tabs__item {
    font-size: 15px;
  }
  .back-box {
    position: absolute;
    right: 20px;
    top: 5px;
    z-index: 1;
    width: 80px;
    height: 30px;
    background: #fd9e01;
    border: 1px solid #fd9e01;
    color: #ffffff !important;
    padding: 0;
    font-size: 14px;
  }
}
</style>